module.exports = __webpack_public_path__ + "img/seven7Green.e761fa9c.jpg";